import { configureStore } from '@reduxjs/toolkit';
import dopplerApi from 'components/Maps/Doppler/dopplerApi';
import deviceReducer from 'features/integrations/state/slices/deviceSlice';
import integrationReducer from 'features/integrations/state/slices/integrationSlice';
import { alarmsApi } from 'services/alarms/alarms.api';
import { alertsApi } from 'services/alerts/alerts.api';
import { devicesApi } from 'services/devices/devices.api';
import { groupsApi } from 'services/devices/groups/groups.api';
import { dutiesApi } from 'services/duties/duties.api';
import { usgsGeoApi } from 'services/geography/usgs/usgs.api';
import { integrationsApi } from 'services/integrations/integrations.api';
import widgetReducer from './slices/Widget/widgetSlice';
import { cleanRTKQuerySlice } from './utils/storeUtils';

const apiSlices = [
  dopplerApi,
  devicesApi,
  usgsGeoApi,
  groupsApi,
  integrationsApi,
  alarmsApi,
  alertsApi,
  dutiesApi,
];
const apiMiddlewares = apiSlices.map((api) => api.middleware);

export const store = configureStore({
  reducer: {
    integration: integrationReducer,
    device: deviceReducer,
    widget: widgetReducer,
    [dopplerApi.reducerPath]: dopplerApi.reducer,
    [devicesApi.reducerPath]: devicesApi.reducer,
    [usgsGeoApi.reducerPath]: usgsGeoApi.reducer,
    [groupsApi.reducerPath]: groupsApi.reducer,
    [integrationsApi.reducerPath]: integrationsApi.reducer,
    [alarmsApi.reducerPath]: alarmsApi.reducer,
    [alertsApi.reducerPath]: alertsApi.reducer,
    [dutiesApi.reducerPath]: dutiesApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(apiMiddlewares),
  devTools: {
    maxAge: 10,
    stateSanitizer: (state) => {
      const cleanedState = { ...state };

      apiSlices.forEach((api) => {
        const apiPath = api.reducerPath;
        cleanedState[apiPath] = cleanRTKQuerySlice(cleanedState[apiPath]);
      });

      return cleanedState;
    },
    actionsDenylist: [],
  },
});
